<template>
  <f7-page class="main-new-crop-page">
    <template #fixed>
      <TheNavbar
        nav-title="Nuevo cultivo"
        back-btn-enable
        :style="appTheme"
      />
    </template>

    <div>
      <form @submit.prevent="addNewCrop">
        <f7-list>
          <li class="padding-horizontal padding-top">
            <div class="item-title item-label">
              Finca
            </div>
          </li>
          <f7-list-item
            title="Finca"
            smart-select
            :smart-select-params="{
              closeOnSelect: true,
              setValueText: false,
            }"
            :after="selectableFields.find((item) => item.id === field)?.name"
          >
            <select
              v-model="field"
              name="field"
            >
              <option
                v-for="(f) in selectableFields"
                :key="f.id"
                :value="f.id"
              >
                {{ f.name }}
              </option>
            </select>
          </f7-list-item>
          <f7-list-input
            class="margin-top"
            label="Descripción"
            type="text"
            placeholder="Descripción"
            required
            validate
            clear-button
            :value="name"
            @input="name = $event.target.value"
          />
          <li class="padding-horizontal margin-top">
            <div class="item-title item-label">
              Variedad
            </div>
          </li>
          <f7-list-item
            class="margin-top"
            title="Variedad"
            smart-select
            required
            validate
            :smart-select-params="{
              closeOnSelect: true,
              searchbar: true,
              searchbarPlaceholder: $t('common.search'),
              setValueText: false,
              cssClass: 'new-crop-smart-select',
            }"
            :after="selectableVarieties.find((item) => item.code === variety)?.name"
          >
            <select
              v-model="variety"
              name="variety"
            >
              <option
                selected
                value=""
              />
              <option
                v-for="(f) in selectableVarieties"
                :key="f.id"
                :value="f.code"
              >
                {{ f.name }}
              </option>
            </select>
          </f7-list-item>
          <f7-list-input
            class="margin-top"
            :label="`Superficie (${surfaceUnit})`"
            type="number"
            placeholder="Superficie"
            required
            validate
            :min="(surfaceUnit === 'Ha') ? 0.0001 : 1"
            :max="maxSurface"
            :step="(surfaceUnit === 'Ha') ? 0.0001 : 1"
            clear-button
            :value="surface"
            @input="surface = $event.target.value"
          />
          <f7-list-input
            class="margin-top plantation-date"
            label="Fecha de plantación"
            type="date"
            placeholder="Fecha de plantación"
            required
            validate
            min="1"
            clear-button
            :value="plantationDate"
            @input="plantationDate = $event.target.value"
          />
          <li class="padding-horizontal margin-top">
            <div class="item-title item-label">
              Campaña
            </div>
          </li>
          <f7-list-item
            title="Campaña"
            smart-select
            :smart-select-params="{
              closeOnSelect: true,
              setValueText: false,
              cssClass: 'new-crop-smart-select',
            }"
            :after="campaings.find((item) => item.id === campaign)?.name"
          >
            <select
              v-model="campaign"
              name="campaign"
            >
              <option
                selected
                value=""
              />
              <option
                v-for="(f) in campaings"
                :key="f.id"
                :value="f.id"
              >
                {{ f.name }}
              </option>
            </select>
          </f7-list-item>
          <li class="padding-horizontal margin-top">
            <div class="item-title item-label">
              Protocolos de calidad
            </div>
          </li>
          <f7-list-item
            title="Protocolos de calidad"
            smart-select
            :smart-select-params="{
              closeOnSelect: true,
              setValueText: false,
              cssClass: 'new-crop-smart-select',
            }"
            :after="selectableProtocols.find((item) => item.id === protocols)?.name"
          >
            <select
              v-model="protocols"
              name="protocols"
              multiple
            >
              <option
                v-for="(f) in selectableProtocols"
                :key="f.id"
                :value="f.id"
              >
                {{ f.name }}
              </option>
            </select>
          </f7-list-item>
        </f7-list>
        <ComplementaryData
          :entity="1024"
          :dcs-data="dcData"
          class="padding-top"
          @data-changed="complementaryDataChanged"
        />
        <f7-block class="margin-top">
          <f7-button type="submit">
            {{ $t('common.save') }}
          </f7-button>
        </f7-block>
      </form>
    </div>
  </f7-page>
</template>

<script>
import TheNavbar from '@/components/TheNavbar.vue';
import ComplementaryData from '@/components/contracts/ComplementaryData.vue';
import FieldService from '@/js/services/contracts/Fields';
import MasterDataService from '@/js/services/contracts/MasterData';
import CropService from '@/js/services/contracts/Crops';
import { LogError } from '@/js/common/HIDebuggingSupport';
import { f7 } from 'framework7-vue';

export default {
  name: 'NewCropPage',
  components: {
    TheNavbar,
    ComplementaryData,
  },
  props: {
    fieldId: { type: Number, default: 0 },
    cropId: { type: Number, default: 0 },
  },

  data() {
    return {
      field: 0,
      selectableFields: [],
      selectableVarieties: [],
      name: '',
      variety: '',
      varietyName: '',
      surface: 0,
      plantationDate: '',
      campaign: 0,
      protocols: [],
      dcData: {},
      campaings: [],
      selectableProtocols: [],
      surfaceUnit: localStorage.getItem('unidadSuperficie'),

    };
  },

  computed: {
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-dark-blue)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    maxSurface() {
      if (this.surfaceUnit === 'Ha') {
        return this.selectableFields.length > 0 ? this.selectableFields[0].surface / 10000
          : Number.MAX_VALUE;
      }
      return this.selectableFields.length > 0 ? this.selectableFields[0].surface
        : Number.MAX_VALUE;
    },
    newCrop() {
      return {
        name: this.name,
        surface: (this.surfaceUnit === 'Ha') ? this.surface * 10000 : this.surface,
        field: this.field,
        variety: this.variety,
        varietyName: this.varietyName,
        plantationDate: this.plantationDate,
        campaign: this.campaign,
        protocols: this.protocols,
        dcs: this.dcData,
      };
    },

  },
  watch: {
    variety(newValue) {
      const variety = this.selectableVarieties.find((v) => v.id === Number.parseInt(newValue, 10));
      this.varietyName = (variety) ? variety.name : '';
    },
  },
  async mounted() {
    await this.loadField();
    await this.loadVarieties();
    await this.loadCampaings();
    await this.loadQualityProtocols();
    if (this.cropId > 0) {
      await this.loadCrop();
    }
  },
  methods: {

    async loadField() {
      const field = await FieldService.getById(this.fieldId);

      if (field) {
        this.selectableFields = [field];
        this.field = field.id;
      }
    },

    async loadCrop() {
      const crop = await CropService.getById(this.cropId);
      this.mapCropToData(crop);
    },
    async loadCampaings() {
      const campaings = await MasterDataService.getAllCampaigns();
      this.campaings = campaings;
    },
    async loadQualityProtocols() {
      const protocols = await MasterDataService.getAllProtocols();
      this.selectableProtocols = protocols;
    },
    mapCropToData(crop) {
      this.name = crop.name;
      this.variety = crop.variety;
      this.surface = (this.surfaceUnit === 'Ha') ? crop.surface / 10000 : crop.surface;
      this.dcData = crop.dcs;
      this.protocols = crop.protocols;
      this.campaign = crop.campaign;
      this.plantationDate = crop.plantationDate;
    },

    async addNewCrop() {
      try {
        const auxCrop = { ...this.newCrop };
        auxCrop.sync_status = 1;
        if (this.cropId > 0) {
          await CropService.updateById(this.cropId, auxCrop);
        } else {
          await CropService.add(auxCrop);
        }

        f7.views.main.router.back('', { ignoreCache: true });
      } catch (e) {
        LogError(this, this.addNewCrop.name, e);
      }
    },
    complementaryDataChanged(newValue) {
      this.dcData = newValue;
    },
    async loadVarieties() {
      const varieties = await MasterDataService.getAllVarieties();
      this.selectableVarieties = varieties;
    },
  },
};
</script>

<style lang="scss">
.main-new-crop-page {
  --input-right-separation: 32px;

  .page-content {
    background: var(--his-whispering-lilac);
  }

  .plantation-date {
    input {
      padding-right: var(--input-right-separation);
    }
  }

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="month"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  .smart-select .item-content .item-inner,
  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }

  .item-content {
    .item-inner {
      .item-input-wrap {
        input {
          height: 50px;
          padding-left: 10px;
        }

        .input-clear-button {
          margin-top: -4px;
          margin-right: var(--input-right-separation);
        }
      }
    }
  }
}

.new-crop-smart-select {
  --f7-navbar-bg-color: var(--his-dark-blue);
}
</style>
